import React from "react";
import { USE_CASES } from "../../mock";
import Reveal from "./Reveal";

const UseCases = () => (
  <section id="usecases" className="relative py-24 sm:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div className="max-w-2xl">
            <span className="text-sm font-semibold uppercase tracking-wider text-primary">Use cases</span>
            <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
              Put the busywork on autopilot
            </h2>
          </div>
          <p className="max-w-sm text-muted-foreground">
            CSV, Excel, JSON, text-based PDF and TXT files.
          </p>
        </div>
      </Reveal>

      <div className="mt-14 grid gap-6 md:grid-cols-3">
        {USE_CASES.map((u, i) => (
          <Reveal key={u.title} delay={i * 100}>
            <div className="group h-full overflow-hidden rounded-2xl border border-border bg-card transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-primary/5">
              <div className="relative overflow-hidden">
                <img src={u.img} alt={u.title} className="aspect-[16/11] w-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
                <span className="absolute left-4 top-4 flex h-10 w-10 items-center justify-center rounded-xl bg-background/90 text-primary shadow-sm backdrop-blur">
                  <u.icon className="h-5 w-5" strokeWidth={2} />
                </span>
              </div>
              <div className="p-6">
                <h3 className="font-display text-lg font-semibold text-foreground">{u.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{u.desc}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default UseCases;
